export const ENABLE_MFA_CALLOUT = "EnableMFACallout";
export const FILTERS_ORDER_SETTINGS_KEY = "organizationMFAKeysFiltersOrder";
